import { Search } from "@mui/icons-material";
import { Grid, MenuItem, TextField, Tooltip } from "@mui/material";
import { css, StyleSheet } from "aphrodite";
import { formatCPF } from "../../helpers/format";
import Select from "react-select";

type FilterAlunosProps = {
  searchStudents: () => void;
  searchCpf: string;
  setSearchCpf: React.Dispatch<React.SetStateAction<string>>;
  searchNome: string;
  setSearchNome: React.Dispatch<React.SetStateAction<string>>;
  searchEmail: string;
  setSearchEmail: React.Dispatch<React.SetStateAction<string>>;
  searchSituacao: string[];
  setSearchSituacao: React.Dispatch<React.SetStateAction<string[]>>;
};

export const FilterAlunos = ({
  searchStudents,
  searchCpf,
  searchNome,
  searchEmail,
  setSearchCpf,
  setSearchNome,
  setSearchEmail,
  searchSituacao,
  setSearchSituacao,
}: FilterAlunosProps) => {
  const situacoesOptions = [
    { value: "1", label: "Ativado" },
    { value: "2", label: "Cancelado" },
    { value: "3", label: "Trancado" },
    { value: "4", label: "Travado" },
    { value: "5", label: "Concluído" },
  ];

  return (
    <Grid
      container
      spacing={1} // Reduz o espaçamento
    >
      <Grid size={{ xs: 12, sm: 6, md: 3.5, lg: 3 }}>
        <TextField
          label="CPF"
          size="small"
          fullWidth
          value={searchCpf}
          onChange={(e) => formatCPF(e.target.value, setSearchCpf)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              searchStudents();
            }
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3.5, lg: 2.5 }}>
        <TextField
          label="Nome"
          size="small"
          fullWidth
          value={searchNome}
          onChange={(e) => setSearchNome(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              searchStudents();
            }
          }}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 3.5, lg: 2.5 }}>
        <TextField
          label="E-mail"
          size="small"
          fullWidth
          value={searchEmail}
          onChange={(e) => setSearchEmail(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              searchStudents();
            }
          }}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 3.5, lg: 2 }}>
        <Select
          options={situacoesOptions}
          isClearable
          isMulti
          placeholder="Situação"
          value={situacoesOptions.filter((o) =>
            searchSituacao.includes(o.value)
          )}
          onChange={(opts) => {
            const values = (opts || []).map((o) => o.value);
            setSearchSituacao(values);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") searchStudents();
          }}
          styles={{
            container: (base) => ({
              ...base,
            }),
            placeholder: (base) => ({
              ...base,
              color: "#cacaca",
              fontSize: 12,
            }),
            input: (base) => ({
              ...base,
              fontSize: 12,
            }),
            menuList: (base) => ({
              ...base,
              fontSize: 12,
            }),
            multiValue: (base) => ({
              ...base,
              fontSize: 12,
            }),
          }}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 2, md: 1.5, lg: 0.5 }}>
        <Tooltip title={"Buscar"}>
          <button className={css(styles.btn)} onClick={searchStudents}>
            <Search />
          </button>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

const styles = StyleSheet.create({
  pageTitle: {
    fontFamily: "Poppins",
    fontWeight: 600,
    color: "#4b4b4b",
  },
  input: {
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 400,
    color: "#808080",
    transitionDuration: "0.2s",
  },
  btn: {
    cursor: "pointer",
    backgroundColor: "#004AAD",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#004AAD",
    borderRadius: 6,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    padding: "0.5rem 0.3rem 0.42rem 0.4rem",
    width: "100%",
    // marginTop: "1.95rem",
    transitionDuration: "0.2s",
    ":hover": {
      color: "#004AAD",
      backgroundColor: "transparent",
      borderColor: "#004AAD",
    },
    ":active": {
      color: "#004AAD",
      backgroundColor: "transparent",
      borderColor: "#004AAD",
      opacity: 0.6,
    },
  },
  btnDisabled: {
    backgroundColor: "#B3B3B3",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#B3B3B3",
    borderRadius: 6,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    padding: "0.5rem 0.3rem 0.42rem 0.4rem",
    width: "100%",
    marginTop: "1.95rem",
  },
  erro: {
    fontSize: 14,
    color: "red",
    textAlign: "center",
    fontWeight: 600,
    marginTop: "1rem",
    marginBottom: "-0.5rem",
  },
  topBtn: {
    backgroundColor: "#004AAD",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#004AAD",
    borderRadius: 6,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    padding: "0.5rem 0.5rem 0.5rem 0.5rem",
    transitionDuration: "0.2s",
    ":hover": {
      color: "#186ad6ff",
      backgroundColor: "transparent",
      borderColor: "#186ad6ff",
    },
    ":active": {
      color: "#004AAD",
      backgroundColor: "transparent",
      borderColor: "#004AAD",
      opacity: 0.6,
    },
  },
});
